<div *ngIf="isText" class="form-group-inline">
    <ng-template [ngTemplateOutlet]="beforeInput"></ng-template>
    <input class="inputField" [ngClass]="class" [type]="type" [id]="uniqueId" [(ngModel)]="textValue" [disabled]="disabled" (input)="onInput($event)"/>
    <common-form-input-tooltip *ngIf="dataToolTip" [value]="dataToolTip"></common-form-input-tooltip>
    <ng-template [ngTemplateOutlet]="afterInput"></ng-template>
</div>

<div *ngIf="isFile" class="form-group-inline">
    <input type="file" class="inputField inputField--file" [ngClass]="class"
           [(ngModel)]="fileValue" (input)="onFileInput($event)" [disabled]="disabled">
</div>

<div *ngIf="isSelect" class="form-group-inline">
    <common-form-select class="form-input--select"
                        [items]="items" (selected)="onSelected($event)" (reset)="onResetSelection()" [resetText]="resetText"
                        [class]="class" [displayValue]="displayValue" [modelValue]="modelValue"
                        [showScrollbar]="showScrollbar" [showReset]="showReset"
                        [disabled]="disabled"
                        [model]="value">
        <input #selectInput class="inputField form-input__select_input" [ngClass]="class" [id]="uniqueId"
               placeholder="{{i18n.formInputComponent.placeholder}}"
               [disabled]="disabled" [(ngModel)]="selectionLabel" readonly="readonly"/>
        <ng-content></ng-content>
    </common-form-select>
    <common-form-input-tooltip *ngIf="dataToolTip" [value]="dataToolTip"></common-form-input-tooltip>
</div>

<div *ngIf="isTextarea" class="form-group-inline">
    <textarea class="inputTextarea" [ngClass]="class" [rows]="textareaRows"
              [id]="uniqueId"
              [(ngModel)]="textValue"
              [disabled]="disabled"
              [readonly]="readonly"
              (input)="onInputTextarea($event)">
    </textarea>
    <common-form-input-tooltip *ngIf="dataToolTip" [value]="dataToolTip"></common-form-input-tooltip>
</div>

<div *ngIf="isBox" [ngClass]="{'form-group':class === 'vertical','form-group-inline': class?.indexOf('inline') > -1}">
    <div *ngFor="let key of keysForBox, let last = last" class="inputComponent form-group-inline">
        <input [attr.id]="key" [name]="name" [type]="type"
               [ngClass]="{
                    'inputClickable inputClickable--radio': type === 'radio',
                    'checked':value === key,'':value !== key
                }"
               (click)="onBoxChange(key)"
               [disabled]="disabled || (disabledItems && disabledItems.indexOf(key) !== -1)"
               [title]="labelTitle"/>
        <span *ngIf="type === 'radio'" [ngClass]="{'icon-radio_button_unchecked' : value !== key,
                          'icon-radio_button_checked' : value === key}">
        </span>
        <label [attr.for]="key" [title]="labelTitle" class="inpLabel" [ngClass]="class">{{items[key]}}</label>
        <common-form-input-tooltip *ngIf="dataToolTip && last" [value]="dataToolTip"></common-form-input-tooltip>
    </div>

    <div *ngIf="noItems" class="inputComponent form-group-inline">
        <input [attr.id]="uniqueId" [name]="name" [type]="type"
               (click)="onBoxChange()"
               [disabled]="disabled"
               [checked]="value"
               [ngClass]="{
                    'inputClickable': type === 'checkbox',
                    'inputClickable--checkbox':type === 'checkbox' && !dataToolTip,
                    'checked': value,
                    'inputClickable--checkbox_with_tooltip': type === 'checkbox' && dataToolTip
                }"
               [title]="labelTitle"/>
        <span *ngIf="type === 'checkbox'"
              [ngClass]="{'icon-check_box_outline_blank' : !value,
                          'icon-check_box' : value}"
        ></span>
        <label *ngIf="label" [attr.for]="uniqueId" [title]="labelTitle" class="inpLabel" [ngClass]="class">{{label}}</label>
        <common-form-input-tooltip *ngIf="dataToolTip" [value]="dataToolTip"></common-form-input-tooltip>
    </div>
    <ng-content></ng-content>
</div>
